import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';
import { useLabels } from 'wsm-common-data';

export const Filter = ({ type, options, currentValue, handleChange }) => {
	const labels = useLabels();
	const groupClasses = [
		'd-block',
		'd-sm-inline-block',
		'form-group',
		'p-0',
		'mr-sm-3',
		'mb-3'
	];
	const selectClasses = ['form-control', 'pr-9', type];
	const typeLabel = labels.get(type.toUpperCase());

	return (
		<div className={setClassNames(groupClasses)}>
			<select
				className={setClassNames(selectClasses)}
				onChange={(e) => handleChange(type, e.target.value)}
				aria-label={`${labels.get('SELECT')} ${typeLabel}`}
				value={currentValue}
			>
				<option value={type}>{typeLabel}</option>
				{options.map((option) => (
					<option value={option} key={option}>
						{option}
					</option>
				))}
			</select>
		</div>
	);
};
Filter.propTypes = {
	type: PropTypes.string.isRequired,
	options: PropTypes.arrayOf(PropTypes.string).isRequired,
	currentValue: PropTypes.string.isRequired,
	handleChange: PropTypes.func.isRequired
};
